export default __webpack_public_path__ + "static/media/back.4267b0c1.png";